import React from 'react';
import { useLocation } from "react-router-dom";
import { NavbarBrand, Nav } from 'reactstrap';
import { BsFacebook, BsInstagram, BsEnvelope, BsWhatsapp } from 'react-icons/bs';

import { LoginNavItem, LoginNavItemMobile } from './CustomLoginNavItem/LoginNavItem';
import Menu from './Menu';

import './Header.scss';
import './HeaderSearch.scss';

import logo from '../../assets/img/site/Celuba-logo.gif';

const SearchTopHeader = () => (
  <>
    
    <div className="container-fluid headerSearch__brand d-flex flex-column justify-content-between">
      
      <NavbarBrand href="/">
        <img className="img-fluid" src={logo} alt="Celuba" />
      </NavbarBrand>
      
      <section className="header__top d-none d-md-flex justify-content-end align-items-center">
        <a title="Seguinos..." className="d-none d-md-block header__link" target="_blank" href="https://www.facebook.com/CelubaBahiaBlanca"><BsFacebook /></a>
        <a title="Seguinos..." className="d-none d-md-block header__link" target="_blank" href="https://www.instagram.com/celuba_bahiablanca/?hl=es"><BsInstagram /></a>
        {/* <a title="Consúltanos..." className="d-none d-md-block header__link" target="_blank" href="https://api.whatsapp.com/send?phone=542915111792&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20"><BsWhatsapp /></a> */}
        <a title="Consúltanos..." className="d-none d-md-block header__link mr-3" target="_blank" href="mailto:celubagmail.com"><BsEnvelope /></a>

        <div className="header__loguin">
          <Nav>
            <LoginNavItem closeHeader={false} />
          </Nav>
        </div>
      </section>
      
      <Menu />

    </div>
  </>
)

// const TopHeader = () => (
//   <React.Fragment>
//     <section className="header__top d-none d-md-flex justify-content-end">
//       <div className="header__loguin">
//         <Nav>
//           <LoginNavItem closeHeader={false} />
//         </Nav>
//       </div>
//     </section>
//     <NavbarBrand href="https://www.celuba.com.ar/">
//       <img className="img-fluid" src={logo} alt="celuba" />
//     </NavbarBrand>
//   </React.Fragment>
// )

const Header = (props) => {

  const { pathname } = useLocation();
  const isRoot = pathname === "/";

  return (
    <header className="headerSearch">
      <SearchTopHeader />
    </header>
  );
};

export default Header;
